<template>
  <div class="custom-grid" :style="imageStyle">
    <el-image
      :style="imageStyle"
      :fit="fit"
      :src="src"
      :preview-src-list="[src]"
      @wheel.native.prevent="() => {}"
    >
      <div slot="error" class="image-slot">
        <span v-if="error">{{ error }}</span>
        <i v-else class="el-icon-picture-outline" />
      </div>
    </el-image>
    <div class="lebal">{{ lebal }}</div>
  </div>
</template>

<script>
export default {
  props: {
    error: {
      type: String,
      default: ""
    },
    imageStyle: {
      type: Object,
      default() {
        return {
          width: "150px",
          height: "150px"
        };
      }
    },
    fit: {
      type: String,
      default: "contain"
    },
    src: {
      type: String,
      default: ""
    },
    lebal: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  created() {},
  methods: {}
};
</script>
<style lang="scss">
.custom-grid {
  .el-image .image-slot {
    width: 98% !important;
    height: 98% !important;
  }
  .el-image__inner {
    width: 98%;
    height: 98%;
  }
}
</style>
<style scoped lang="scss">
.custom-grid {
  display: inline-block;
  font-size: 14px;
  color: #8c939d;
  margin-right: 20px;
  border: 1px dashed #c0ccda;
}
::v-deep .el-image .image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
}
.lebal {
  white-space: nowrap;
  width: 190px;
}
</style>
